document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("global-landing-page")) {
        import(/* webpackChunkName: "global-landing" */ "/Features/GlobalLanding/js/global-landing.js").then(async (module) => {
            const globalLandingPage = new module.default();
            await globalLandingPage.init();
        });
    }
});